export class ApiResponse {

  public message?: string;
  public data: any;
  public errors?: any[] | Map<string, string>;

}
